export default [
  {
    path: "/thesisDetail", //论文详情//fns
    name: "thesisDetail",
    component: (resolve) =>
      require(["@/views/PCView/details/paperDetails/details.vue"], resolve),
  },
  {
    path: "/msgDetails", //资讯详情//fns
    name: "msgDetails",
    component: (resolve) =>
      require(["@/views/PCView/details/msgDetails/index.vue"], resolve),
  },
  {
    path: "/solicitationDetails", //征稿函详情//fns
    name: "solicitationDetails",
    component: (resolve) =>
      require([
        "@/views/PCView/details/solicitationDetails/index.vue",
      ], resolve),
  },
  {
    path: "/thesisDetail", //精选详情 //fns
    name: "thesisDetail",
    component: (resolve) =>
      require(["@/views/PCView/details/selectedDetails/index.vue"], resolve),
  },
  {
    path: "/meetingDetails", //会议详情
    name: "meetingDetails",
    component: (resolve) =>
      require(["@/views/PCView/details/meetingDetails/index.vue"], resolve),
  },
  {
    path: "/dataDetails", //万商数据详情
    name: "dataDetails",
    component: (resolve) =>
      require(["@/views/PCView/details/dataDetails/index.vue"], resolve),
  },
  {
    path: "/concentrationDetails", // 专著详情
    name: "concentrationDetails",
    component: (resolve) =>
      require([
        "@/views/PCView/details/concentrationDetails/index.vue",
      ], resolve),
  },
  {
    path: "/courseDetails", // 课程详情
    name: "courseDetails",
    component: (resolve) =>
      require(["@/views/PCView/details/courseDetails/index.vue"], resolve),
  },
  {
    path: "/videoDetails", //
    name: "videoDetails",
    component: (resolve) =>
      require(["@/views/PCView/details/video/index.vue"], resolve),
  },
];
